import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers/index';
import { rmsLoadAvailableContracts } from '@ordersnproducts/modules/shared/utils/open-platform/rms-contracts-with-balance-loader.helper';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { getOpenPlatformContractData } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/contracts.selectors';

@Injectable()
export class ContractsBalanceOptionLoaderOpenPlatformService implements SelectOptionLoaderI {
  constructor(
    private store: Store<OrderBuilderState>,
    private translate: TranslateService,
  ) {}

  /**
   * Provides an observable of the products
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOpenPlatformContractData),
      filter(
        ({ availableContract, contractbalance, customer }) =>
          !!availableContract && Object.keys(contractbalance).length > 0,
      ),
      map(({ availableContract, contractbalance, customer }) => {
        const productCode = formGroup.get(SpecFieldNames.PRODUCT_SELECTION).value;
        const contracts = availableContract[productCode];
        if (contracts) {
          return rmsLoadAvailableContracts(contracts, contractbalance, this.translate, true, customer.countryCode);
        }
        return [];
      }),
    );
  }
}
